var render, staticRenderFns
import script from "./Deckplan.vue?vue&type=script&lang=js&"
export * from "./Deckplan.vue?vue&type=script&lang=js&"
import style0 from "./Deckplan.vue?vue&type=style&index=0&id=e55da832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55da832",
  null
  
)

export default component.exports